import { Injectable } from '@angular/core';
import { ProviderSubscriptionCatalog } from '@models';
import { HttpService } from '@services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProviderSubscriptionCatalogApiService extends HttpService<void> {
  protected override readonly collectionPath =
    '/admin/provider-subscriptions/catalog';

  getCatalog(): Observable<ProviderSubscriptionCatalog> {
    return this.http.get<ProviderSubscriptionCatalog>(this.apiUrl);
  }
}
